




















import useMessagingFilters from "@/composables/useMessagingFilters";
import { useInboxModuleType } from "@/composables/v2.1/useInboxModuleType";
import useMessagingStatusFilters from "@/composables/v2.1/useMessagingStatusFilters";
import { StatusFilterNameType } from "@/types/filter.types";
import numberLimiter from "@/utils/numberLimiter.util";
import { ReadDto } from "@saysimple-platform/dtos";
import { computed, defineComponent } from "@vue/composition-api";
import { BBadge, BNav, BNavItem } from "bootstrap-vue";

export default defineComponent({
    components: {
        BBadge,
        BNav,
        BNavItem,
    },
    setup() {
        const { inboxModuleType } = useInboxModuleType();
        const { statusFilters, resolveUnreadChatStatusFilter, filterUnreadChats } = useMessagingStatusFilters();
        const { getActiveFilter: activeFilter, setActiveFilter } = useMessagingFilters();

        const computedUnreadCounters = computed(() => {
            return filterUnreadChats(inboxModuleType.value).reduce(
                (filterResult: { [key in StatusFilterNameType]: ReadDto[] }, unreadChat: ReadDto) => {
                    resolveUnreadChatStatusFilter(unreadChat).forEach((statusFilterNameType: StatusFilterNameType) => {
                        filterResult[statusFilterNameType].push(unreadChat);
                    });

                    return filterResult;
                },
                {
                    [StatusFilterNameType.NEW]: [],
                    [StatusFilterNameType.OPEN]: [],
                    [StatusFilterNameType.TEAM]: [],
                    [StatusFilterNameType.PERSONAL]: [],
                    [StatusFilterNameType.ARCHIVE]: [],
                }
            );
        });

        return {
            activeFilter,
            computedUnreadCounters,
            statusFilters,
            setActiveFilter,
            numberLimiter,
        };
    },
});
